import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ReactComponent as VeuitLogo } from "../../assets/images/veuit-logo.svg";
import { ReactComponent as Success } from "../../assets/images/Success.svg";

const mapStateToProps = (state) => {
    return {
    };
}


const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(
        {
        },
        dispatch
    )
})

export class ChannelPaymentSuccess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <section className="sign-in-page">
                <Container>
                    <Row className="row justify-content-center align-items-center height-self-center">
                        <Col lg="5" className="align-self-center forgot-pwd-height" id="set-sign-in">
                            <div className="sign-user_card ">
                                <div className="sign-in-page-data text-center">
                                    <div className="sign-in-from m-auto">
                                        <div className="sign-in-logo">
                                            <Link to="/"> <VeuitLogo /></Link>
                                        </div>
                                        <div className="form-bg-mobile">
                                            <Success className='payment-img' />
                                            <h3 className='mt-3 mb-0 text-success'><strong>Success !</strong></h3>
                                            <p className="text-white" id='payment-msg'>
                                                {"Thank you for creating veuit channel. Your channel will be activated within 24 hours. Kindly refer to your email for further details."}
                                            </p>
                                            <div className="d-inline-block w-100">
                                                <Link to="/" className="btn btn-primary mt-3" id='payment-back'>Back to Home</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChannelPaymentSuccess)